import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { ServiceAreaMap } from './ServiceAreaMap';
import { business, serviceCities } from '../data/business';
export function ServiceArea() {
  return <section id="area" className="scroll-mt-20 bg-navy py-20 lg:py-28" aria-labelledby="area-title" data-id="element-246" data-mp="s23s7hzz6n0d">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:items-center lg:gap-16 lg:px-8" data-id="element-247" data-mp="n9an2t0lhcnr">
        <div className="lg:col-span-5" data-id="element-248" data-mp="11xydkkvl2w6u">
          <h2 id="area-title" className="font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-249" data-mp="1212rwb2rj8b8">
            Pool Renovation in Orlando &amp; Central Florida
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-250" data-mp="16ym7beb75r4r">
            Innova Pools &amp; Systems serves homeowners throughout Orlando, Kissimmee, Winter Garden, Clermont and
            surrounding Central Florida communities.
          </p>

          <ul className="mt-8 grid grid-cols-2 gap-3" data-id="element-251" data-mp="38ripdl3ixtyd">
            {serviceCities.map((city, i) => <li key={city} className={`flex items-center gap-2.5 rounded-xl px-4 py-3.5 text-[15px] font-semibold ${i === 0 ? 'bg-accent text-navy' : 'bg-white/10 text-white ring-1 ring-white/15'}`} data-id="element-252" data-mp="1a9ruh9v4sfy6" data-mpi={i}>
                <MapPinIcon className={`h-4 w-4 shrink-0 ${i === 0 ? 'text-navy' : 'text-accent'}`} aria-hidden="true" data-id="element-253" data-mp="1oyflr3xy23ib" />
                {city}
              </li>)}
          </ul>

          <p className="mt-8 text-[15px] text-white/70" data-id="element-254" data-mp="1xw81g97kvd68">Not sure if we cover your neighborhood?</p>
          <a href={business.phoneHref} className="mt-2 inline-flex items-center gap-2 text-lg font-bold text-accent transition-colors duration-150 hover:text-white" data-id="element-255" data-mp="22xxgdzxx8azl">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-256" data-mp="8jwfzamq3fxe" />
            Call us at {business.phoneDisplay}
          </a>
        </div>

        <div className="lg:col-span-7" data-id="element-257" data-mp="djitll6gqy6q">
          <div className="aspect-[5/4] overflow-hidden rounded-2xl bg-navy-900 ring-1 ring-white/10" data-id="element-258" data-mp="5i1hcarraqpb">
            <ServiceAreaMap data-id="element-259" data-mp="1gg7kyaiqsjc" />
          </div>
        </div>
      </div>
    </section>;
}